import * as React from 'react';
import Separator from '@telia-front/separator';
import Text from '@telia-front/text';
import Tooltip from '@telia-front/tooltip';
import TooltipToggle from '@telia-front/tooltip-toggle';
import NecessitiesInfo from './necessities-info';
const ChannelTooltip = (props) => {
    const { channel, fontWeight = 'bold' } = props;
    const renderTooltip = () => {
        return (React.createElement(Tooltip, { referenceElement: `#${channel.id}-tooltip` },
            channel.description && React.createElement("div", null, channel.description),
            channel.viewingNecessitiesDescription && (React.createElement(React.Fragment, null,
                React.createElement(Separator, { spacing: "xxsmall", color: "invisible" }),
                React.createElement(Text, null,
                    React.createElement(NecessitiesInfo, { content: channel.viewingNecessitiesDescription, headingLevel: 5 }))))));
    };
    return (React.createElement(React.Fragment, null, channel.description || channel.viewingNecessitiesDescription ? (React.createElement(React.Fragment, null,
        React.createElement(TooltipToggle, { id: `${channel.id}-tooltip`, className: fontWeight === 'bold' ? 'text-bold' : undefined }, channel.title),
        renderTooltip())) : (React.createElement("p", { className: fontWeight === 'bold' ? 'text-bold' : undefined }, channel.title))));
};
export default ChannelTooltip;
